<h2 mat-dialog-title>{{id? 'Update Admin' : 'Add Admin'}}</h2>
<form [formGroup]="addUserForm" (ngSubmit)="onFormSubmit()">
    <div mat-dialog-content class="content">
        <div class="column">

            <mat-form-field appearance="outline">
                <mat-label>Mobile</mat-label>
                <input [ngModel]="mobile" formControlName="mobile" maxlength="10" matInput
                    placeholder="Enter Your Registered Mobile Number" (input)="onMobileInputChange()">
            </mat-form-field>

            <!-- <mat-form-field class="example-full-width" appearance="outline">
                <mat-label>Mobile</mat-label>
                <input #input type="text" placeholder="Enter Mobile" matInput [matAutocomplete]="auto"
                    (input)="filter()" (focus)="filter()" [ngModel]="mobile" formControlName="mobile">
                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onUserSelectionChanged($event)">
                    <mat-option *ngFor="let option of filteredOptions" [value]="option">
                        {{ option.user_mobile }}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field> -->
        </div>

        <div class="column">
            <mat-form-field appearance="outline" class="flex-1">
                <mat-label>Password</mat-label>

                <input matInput [ngModel]="user_pwd" formControlName="user_pwd" [readonly]="!isResetMode"
                    [type]="isResetMode ? 'text' : 'password'" placeholder="Enter Password">

                <!-- Reset Icon -->
                <button *ngIf="!isResetMode" mat-icon-button matSuffix type="button" (click)="resetPassword()"
                    matTooltip="Reset Password">
                    <mat-icon color="warn">edit</mat-icon>
                </button>

            </mat-form-field>
        </div>

        <div class="column">
            <mat-form-field appearance="outline">
                <mat-label>Username</mat-label>
                <input [ngModel]="user_name" formControlName="user_name" matInput placeholder="Enter User Name">

            </mat-form-field>
        </div>

        <div class="column">
            <mat-form-field appearance="outline">
                <mat-label>Role</mat-label>
                <mat-select [ngModel]="role" formControlName="role">
                    <mat-option value="subadmin">Sub-Admin</mat-option>
                    <mat-option value="volunteer">Volunteer</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div mat-dialog-actions class="action" align="end">
            <button mat-raised-button type="button" color="warn" [mat-dialog-close]="false">Cancel</button>
            <button mat-raised-button type="submit" color="primary">{{id? 'Update' : 'Add'}}</button>
        </div>
    </div>
</form>